module.exports = __webpack_public_path__ + "static/media/img-manner-eating.ad7b780d.svg";